import { useQuery } from "@tanstack/react-query"
import { getBuyerAddresses } from "@/lib/api/buyer.api"
import { useAuthStore } from "@/store/auth.store"

export function useBuyerAddresses() {
  const token = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["buyer-addresses"],
    queryFn: async () => {
      if (!token) throw new Error("No token available")
      return getBuyerAddresses(token)
    },
    enabled: !!token,
  })
}
